import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './Header.style';

const Header = ({ children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <div className={styles.bg}>
      <Stack className={className} {...other}>
        {children}
      </Stack>
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

Header.defaultProps = {
  className: '',
  fullWidth: false,
};

export default Header;
